module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogProductsRecommended":{"heading":"Vybráno pro vás"}}}')
  delete Component.options._Ctor
}
